var customSelect = require('../utils/_customSelect');

class mTileColor extends HTMLUListElement {
    constructor() {
        super();
        this.btnColors = this.querySelectorAll('[data-attr="color"]');
        this.productTile = this.closest('[is="m-product-tile"]');
        this.productTileParent = this.productTile.parentElement;
        this.tileTemplate = this.productTile.dataset.tileTemplate; // either 'default' / 'cross-sell' / 'search-sidebar'

        this.changeProductColor = this.changeProductColor.bind(this);
    }

    connectedCallback() {
        for (var btn of this.btnColors) {
            btn.addEventListener('click', this.changeProductColor);
        }
    }

    getSwatchIds() {
        const swatchIds = [];
        this.btnColors.forEach(elem => {
            if ('attrValue' in elem.dataset) {
                swatchIds.push(elem.dataset.attrValue);
            }
        });
        return swatchIds;
    }

    changeProductColor(e) {
        var el = e.currentTarget;
        const url = new URL(el.dataset.value);
        url.searchParams.set('tileTemplate', this.tileTemplate);

        const swatchIds = this.getSwatchIds();
        if (swatchIds.length > 0) {
            url.searchParams.set('swatchOrder', swatchIds.join(','));
        }

        if (url) {
            fetch(url.toString(), {
                Method: 'GET'
            }).then((response) => {
                return response.text();
            }).then((htmlProductColor) => {
                this.productTile.outerHTML = htmlProductColor;
                this.productTile.setCta();
                customSelect.initCustomSelect(this.productTileParent);
            });
        }
    }
}

customElements.define('m-tile-color', mTileColor, {
    extends: 'ul'
});
